import { useEffect, useState } from "react";
import sisepCardFallback from "../assets/images/fallback/sisep-card.png";

export const SISEP_IMAGE_FALLBACK = sisepCardFallback;

const FALLBACK_FLAG = "sisepFallback";

export function withImageFallback(src?: string | null) {
  return src && String(src).trim() ? src : SISEP_IMAGE_FALLBACK;
}

export function useImageSrc(src?: string | null) {
  const [current, setCurrent] = useState(() => withImageFallback(src));

  useEffect(() => {
    const next = withImageFallback(src);

    if (next === SISEP_IMAGE_FALLBACK) {
      setCurrent(SISEP_IMAGE_FALLBACK);
      return;
    }

    const image = new Image();
    image.onload = () => setCurrent(next);
    image.onerror = () => setCurrent(SISEP_IMAGE_FALLBACK);
    image.src = next;

    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, [src]);

  return current;
}

export function installImageFallback() {
  const onError = (event: Event) => {
    const target = event.target;
    if (!(target instanceof HTMLImageElement)) {
      return;
    }
    if (target.dataset[FALLBACK_FLAG] === "1") {
      return;
    }
    target.dataset[FALLBACK_FLAG] = "1";
    target.src = SISEP_IMAGE_FALLBACK;
  };

  document.addEventListener("error", onError, true);
  return () => document.removeEventListener("error", onError, true);
}
